// Module
var code = "<span class=\"view-comfort-dropdown\"> <eye class=\"before\"></eye> <select class=\"select\" ng-model=\"vm.view\" ng-change=\"vm.onUpdate({ view: vm.view })\" ng-options=\"option.value as option.key for option in vm.options\"></select> <caret-down-icon class=\"after\"></caret-down-icon> </span> ";
// Exports
module.exports = code;